<template>
  <nav class="TheNavbar" v-bind="$attrs">
    <UIContainer class="TheNavbar__container" :withPadding="false">
      <RouterLink :to="{ name: 'Landing' }" class="TheNavbar__logo-link">
        <img
          class="TheNavbar__logo-sustainalyse"
          src="/images/sustainalyse-logo.svg"
          alt="Sustainalyse logo"
        />
      </RouterLink>

      <TheNavbarMobile class="TheNavbar__mobile" :links="links" />

      <TheNavbarDesktop class="TheNavbar__desktop" :links="links" />
    </UIContainer>
  </nav>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import TheNavbarMobile from './components/TheNavbarMobile.vue'
import TheNavbarDesktop from './components/TheNavbarDesktop.vue'
import { RouteLocationRaw } from 'vue-router'
import { IIcons } from '../../icons/types'

export interface INavbarItem {
  label: string
  description?: string
  icon?: IIcons
  link?: Partial<RouteLocationRaw>
  items?: INavbarItem[]
}
const links: INavbarItem[] = [
  {
    label: 'Solutions',
    items: [
      {
        label: 'Carbon Accounting',
        icon: 'topbarCo2',
        description: 'Measure an accurate full scope carbon footprint',
        link: { name: 'CarbonAccounting' },
      },
      {
        label: 'Net Zero',
        icon: 'topbarNetZero',
        description: 'Build a science-backed roadmap to Net Zero',
        link: { name: 'NetZero' },
      },
      {
        label: 'SBTi Support',
        icon: 'topbarSBTI',
        description: 'Get support on your journey to SBTi',
        link: { name: 'SBTi' },
      },
      // {
      //   label: 'ESRS/VSME/GRI',
      //   icon: 'topbarStandards',
      //   description:
      //     'Automate compliance with flexible ESG software',
      //   link: { name: 'SBTi' },
      // },
      {
        label: 'ESRS/VSME/GRI',
        icon: 'applicationWeb',
        description: 'Automate reporting with flexible ESG software',
        link: { name: 'ESRSVSMEGRIReporting' },
      },
      {
        label: 'Ecovadis',
        icon: 'topbarEcovadis',
        description: 'Get started and improve your EcoVadis score',
        link: { name: 'Ecovadis' },
      },
    ],
  },
  // {
  //   label: 'Services',
  //   items: [
  //     {
  //       label: 'SBTi',
  //       description: '',
  //       link: { name: 'SBTi' },
  //     },
  //     {
  //       label: 'Net zero',
  //       description: '',
  //       link: { name: 'NetZero' },
  //     },
  //   ],
  // },
  // {
  //   label: 'Academy',
  //   items: [
  //     {
  //       label: 'GHG Calculator',
  //       description: 'Calculate your greenhouse gas emissions.',
  //       link: { name: 'GhgCalculator' },
  //     },
  //     {
  //       label: 'Webinar',
  //       description: 'Join our sustainability webinars.',
  //       link: { name: 'Webinar' },
  //     },
  //     {
  //       label: 'CSRD Check',
  //       description: 'Check your CSRD compliance status.',
  //       link: { name: 'CSRDCheck' },
  //     },
  //   ],
  // },
  { label: 'Contact us', link: { name: 'Contact' } },
]
</script>

<style lang="scss" scoped>
.TheNavbar {
  padding: 1rem 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $color-white;
  z-index: 100;

  @include lg {
    padding: 1.125rem 0;
  }

  .TheNavbar__container {
    height: 2.5rem;
    display: flex;
    align-items: center;
  }

  .TheNavbar__logo-link {
    display: flex;
  }

  .TheNavbar__mobile {
    margin-left: auto;

    @include md {
      display: none;
    }
  }

  .TheNavbar__desktop {
    display: none;

    @include md {
      display: flex;
    }
  }
}
</style>
